import axios from 'axios'

// 根据印度邮编查询城市
const lookupPincode = pincode =>
  axios
    .get('/api/v1/pincode/lookup', { params: { pincode } })
    .then(res => res.data)

export default { lookupPincode }
